var _a;
import { lexieCustomEventSchemas } from '@/events/constants/custom-event-schemas.constant';
import { getEventTracker } from 'hx-analytics';
export var useEvents = (_a = getEventTracker(lexieCustomEventSchemas), _a.useEvents), trackCustom = _a.trackCustom;
